import { useRenderFrameLoop } from './hooks/useRenderFrameLoop'

type RenderFrameLoopProps = {
  frameRateCap: number
}

export const RenderFrameLoop = ({ frameRateCap }: RenderFrameLoopProps) => {
  useRenderFrameLoop(frameRateCap)
  return null
}
